import { render, staticRenderFns } from "./CreditAccountBalance.vue?vue&type=template&id=5d05c95c"
import script from "./CreditAccountBalance.vue?vue&type=script&lang=js"
export * from "./CreditAccountBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports